jQuery(document).ready(function ($) {
    'use strict';
    var windowWidth = $(window).outerWidth();


    // Hero Swiper
    var hero_swiper = new Swiper('.hero-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 2000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1200,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
    });

    // Content block swiper
    var content_swiper = new Swiper('.swiper-container.content-block-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        speed: 700,
        grabCursor: true,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.content-block-swiper .swiper-pagination',
            clickable: true,
        },
    });

    // Big Swiper
    var big_swiper = new Swiper('.swiper-container.big-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        speed: 700,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.big-swiper .swiper-pagination',
            clickable: true,
        },
    });

    // Grid Swiper
    var grid_swiper = new Swiper('.swiper-container.grid-swiper', {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        speed: 500,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.grid-swiper .swiper-pagination',
            clickable: true,
        },
    });

    // Text + image puff slider
    var image_text_puff_swiper = new Swiper('.puffs-text-image-swiper.swiper-container', {
        slidesPerView: 'auto',
        grabCursor: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
        },
        breakpoints: {
            767: {
                centeredSlides: true,
            },
            768: {
                centeredSlides: false, 
            }
        }
    });


    // Show only on mobile
    //if ( windowWidth < 815 ) {
        // Single puff image slider
        var single_puff_swiper = new Swiper('.puff-single-mobile.swiper-container', {
            slidesPerView: 1,
            grabCursor: true,
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
            },
            keyboard: {
                enabled: true,
            },
        });

        // Image puff image slider
        var image_puff_swiper = new Swiper('.puff-images-mobile.swiper-container', {
            slidesPerView: 'auto',
            grabCursor: true,
            slidesOffsetBefore: 0,
            initialSlide: 1,
            spaceBetween: 7,
            centeredSlides: true,
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
            },
            keyboard: {
                enabled: true,
            },
        });
    //}    

});

